import React from 'react';
import './contato.css';

const Contato = () => {

    const contacts = [
    {
      platform: "LinkedIn",
      url: "https://www.linkedin.com/in/vicente-carvalho-33954ab5/",
      icon: "fab fa-linkedin",
      color: "#0077b5",
      description: "Conecte-se profissionalmente"
    },
    {
      platform: "Facebook", 
      url: "https://www.facebook.com/profile.php?id=61574968697330",
      icon: "fab fa-facebook",
      color: "#1877f2",
      description: "Siga nossas atualizações"
    },
    {
      platform: "WhatsApp",
      url: "https://wa.me/5511948112823",
      icon: "fab fa-whatsapp",
      color: "#25d366",
      description: "Conversa direta e rápida"
    },
    {
      platform: "Email",
      url: "mailto:contato@specsbr.com.br",
      icon: "fas fa-envelope",
      color: "#ea4335",
      description: "Envie-nos um email"
    }
  ];

  const handleContactClick = (url, platform) => {
    console.log(`Clicou em ${platform}`);
    window.open(url, '_blank');
  };

    return(

      <div>

<div className="modern-jumbotron">
      <div className="jumbotron-content">
        <div className="text-content">
          <p></p>
          <h1 className="jumbotron-title">Contato</h1>
          <div className="divider"></div>
          <p className="jumbotron-lead">Entre em contato e nos dê a incrível experiência de lhe atender.</p>

          <p className="jumbotron-lead">Estamos disponíveis em vários canais.</p>
        </div>
        
        <div className="visual-content">
          <div className="tech-illustration">
            <div className="code-window">
              <div className="window-header">
                <div className="window-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div className="code-content">
                <div className="code-line"></div>
                <div className="code-line short"></div>
                <div className="code-line"></div>
                <div className="code-line short"></div>
                <div className="code-line"></div>
              </div>
            </div>
            <div className="floating-shape shape-1"></div>
            <div className="floating-shape shape-2"></div>
            <div className="floating-shape shape-3"></div>
          </div>
        </div>
      </div>
      
    </div>



<div className="contact-section-white">  
      <div className="contact-container">
        {/* Cards de Contato */}
        <div className="contact-grid">
          {contacts.map((contact, index) => (
            <div 
              key={index}
              className="contact-card-white"
              onClick={() => handleContactClick(contact.url, contact.platform)}
            >
              <div className="contact-icon" style={{ backgroundColor: contact.color }}>
                <i className={contact.icon}></i>
              </div>
              <div className="contact-info">
                <h3 className="contact-platform">{contact.platform}</h3>
                <p className="contact-description">{contact.description}</p>
                <span className="contact-url">
                  {contact.platform === 'Email' ? 'contato@specsbr.com.br' : contact.url.replace('https://', '').split('/')[0]}
                </span>
              </div>
              <div className="contact-arrow">
                <i className="fas fa-chevron-right" style={{ color: contact.color }}></i>
              </div>
            </div>
          ))}
        </div>

        {/* Informações Adicionais */}
        <div className="contact-footer">
          <div className="response-time">
            <i className="fas fa-clock" style={{ color: '#007bff' }}></i>
            <span>Resposta em até 2 horas úteis</span>
          </div>
          <div className="contact-cta">
            <p>Precisa de um orçamento ou tem um projeto em mente?</p>
            <button className="cta-button-white">
              Iniciar Conversa
              <i className="fas fa-paper-plane"></i>
            </button>
          </div>
        </div>
      </div>
    </div> </div>
    );

}

export default Contato;